<template>
  <section class="home-section" :class="{ 'home-section-tinted': tinted }">
    <div class="home-section-inner">
      <div class="home-section-header">
        <h2 class="home-section-title">{{ title }}</h2>
        <router-link
          v-if="linkTo"
          :to="linkTo"
          class="home-section-link"
          @click.native="$emit('link-click')"
        >
          {{ linkText }} →
        </router-link>
      </div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeSection',
  props: {
    title: {
      type: String,
      required: true
    },
    linkTo: {
      type: String,
      required: false,
      default: ''
    },
    linkText: {
      type: String,
      required: false,
      default: ''
    },
    tinted: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

.home-section {
  background: #fff;
}

.home-section-tinted {
  background: #f7f9f8;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}

.home-section-inner {
  max-width: 1140px;
  margin: 0 auto;
  padding: 3rem 1.5rem;

  @media (min-width: 768px) {
    padding: 4rem 1.5rem;
  }
}

.home-section-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.home-section-title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: $ipBlack;

  @media (min-width: 768px) {
    font-size: 1.75rem;
  }
}

.home-section-link {
  flex-shrink: 0;
  font-size: 0.9375rem;
  font-weight: 500;
  color: $ipGreen;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    color: darken($ipGreen, 8%);
    text-decoration: none;
  }
}
</style>
